import AlphaChar from './alpha-char';

export default AlphaChar;